module.exports = __webpack_public_path__ + "img/hy2-1.67d89778.jpg";